import React from 'react';
import { Map } from 'immutable';
import { Response200Type } from 'src/api_openapi/generated/openapi_proxy_staff_audit_event';

import AuditDetailsBets from './AuditDetailsBets.jsx';
import AuditDetailsAccount from './AuditDetailsAccount.jsx';
import AuditDetailsChat from './AuditDetailsChat.jsx';
import AuditDetailsBanking from './AuditDetailsBanking/AuditDetailsBanking.jsx';
import AuditDetailsLimits from './AuditDetailsLimits/AuditDetailsLimits.jsx';
import { AuditDetailsTradingNew } from './AuditDetailsTradingNew';

type AuditType = Response200Type['results'][number];

interface AuditDetailsPropsType {
    auditDiff: Map<string, unknown>;
    audits: AuditType;
    id: string;
    onGetAuditDiffRequest: (id: string) => void;
}

export const AuditDetails: React.FC<AuditDetailsPropsType> = ({ audits, id }) => {
    const { topic, tags } = audits;

    if (topic.includes('trading_content')) {
        return (
            <div className='audit-details'>
                <AuditDetailsTradingNew
                    audits={audits}
                    id={id}
                />
            </div>
        );
    } else if (topic === 'betting_bets') {
        return (
            <div className='audit-details'>
                <AuditDetailsBets
                    audits={audits}
                    id={id}
                />
            </div>
        );
    } else if (topic === 'accounts_update' || topic === 'accounts_login') {
        return (
            <AuditDetailsAccount
                audits={audits}
                id={id}
            />
        );
    } else if (topic === 'chats') {
        return (
            <AuditDetailsChat
                audits={audits}
                id={id}
            />
        );
    } else if (topic === 'wallet_updates' && tags != null && tags.includes('transactionType-')) {
        return (
            <AuditDetailsLimits
                audits={audits}
                id={id}
            />
        );
    } else if (topic === 'wallet_updates') {
        return (
            <AuditDetailsBanking
                audits={audits}
                id={id}
            />
        );
    } else {
        return null;
    }
};
